import { activeThreadTurnFromState } from "../state.js";
import {
  buildEventStreamPath,
  mergeThreadEvent,
  needsSnapshotRefresh,
  scheduleThreadSnapshotPoll,
  scheduleThreadSnapshotRefresh,
  stopThreadComponentLive,
  threadLiveDeps
} from "../live-shared.js";

export function startHarnessThreadComponentLive(state, apiKey, threadID, options = {}) {
  const deps = { ...threadLiveDeps, ...(options.deps || {}) };
  stopThreadComponentLive(state, deps);
  if (!apiKey || !threadID) {
    return;
  }

  const activeTurn = activeThreadTurnFromState(state);
  if (!activeTurn) {
    state.streamState = "idle";
    options.render?.();
    return;
  }

  const controller = new AbortController();
  state.live.streamAbort = controller;
  state.streamState = "connecting";
  options.render?.();
  scheduleThreadSnapshotPoll(state, apiKey, threadID, options, deps);

  void deps.streamEvents(apiKey, buildEventStreamPath(state, activeTurn.id), {
    signal: controller.signal,
    onEvent(next) {
      const merged = mergeThreadEvent(state, activeTurn.id, next.payload);
      if (merged) {
        options.onThreadEvent?.(next.payload, {
          threadID,
          turnID: activeTurn.id
        });
      }
      if (needsSnapshotRefresh(next.payload.event_type)) {
        scheduleThreadSnapshotRefresh(state, apiKey, threadID, options, deps);
      }
      options.render?.();
    }
  }).then(() => {
    if (!controller.signal.aborted) {
      state.streamState = "closed";
      scheduleThreadSnapshotRefresh(state, apiKey, threadID, options, deps, 0);
      options.render?.();
    }
  }).catch((error) => {
    if (controller.signal.aborted) {
      return;
    }
    state.streamState = "error";
    scheduleThreadSnapshotRefresh(state, apiKey, threadID, options, deps, 0);
    options.setStatus?.(error.message, "error");
    options.render?.();
  });
}
